import React from 'react';
import type { VisualFractionPart } from '../types';
import { getInteractiveProps } from './part-interactions';
import { getEqualTrianglePartPath } from '../../../utils/visual-fraction-geometry';

interface TriangleShapeProps {
  parts: VisualFractionPart[];
  divisions: number;
  onPartClick: (index: number) => void;
}

export const TriangleShape: React.FC<TriangleShapeProps> = ({
  parts,
  divisions,
  onPartClick,
}) => (
  <svg
    className="visual-fraction-widget__shape visual-fraction-widget__triangle"
    viewBox="0 0 100 100"
  >
    {parts.map(part => (
      <path
        key={part.index}
        className={`${part.className} visual-fraction-widget__sector`}
        style={part.style}
        d={getEqualTrianglePartPath(part.index, divisions)}
        {...getInteractiveProps(part, onPartClick)}
      />
    ))}
  </svg>
);

TriangleShape.displayName = 'TriangleShape';
